import React from "react";

const Step = ({ position, onClick }) => {
  const cx = position ? position[0] : 0;
  const cy = position ? position[1] : 0;
  const r = position ? 10 : 0;

  return <circle onClick={onClick} className="icon" cx={cx} cy={cy} r={r} />;
};

export default Step;
